<!--作者：Shujuan Sun
	时间：2017-04-24
	描述：车辆监控页面
-->
<template>
	<div id="monitor">
			<monitor-map></monitor-map>	
			<tab-search></tab-search>
			<!--预警点处理-弹出预警处理详情弹框-->
			<sub-page :show="showSubPage" 
				:bigTitleMsg="subPageTitle" 
				v-on:cancel="closeSubPage" 
				:scroll="scrollTop">
				<div slot="bodycontent">
					<page-alarm-handle-edit 
						:data="alarmDetail"
						v-on:handleSave="saveSubPage">
					</page-alarm-handle-edit>
				</div>
			</sub-page>
			<!--删除围栏、路线、标注弹框-->
			<tab-modal v-on:cancel="closeModalD" ref="modalD" size="small" :title="modalTitle">
				<div v-if="delMap">
					<p>您确定要删除该{{delInfo.type}}吗？</p>
				</div>
				<div v-else>
					<p>您确定要删除名为{{delInfo.panelName}}的车辆关注面板，您确定要继续吗？</p>
				</div>
				<div slot="footer">
					<button class="btn btn-primary" @click="delWithdrawBtn">取消</button>				
					<button class="btn btn-primary" @click="delConfirmBtn">确定</button>
				</div>	
			</tab-modal>
			<!--tabModal弹框->from DeviceInstructions-->
			 
			<tab-modal v-on:cancel="closeModal1" ref="modal1" size="normal" :title="curInst.name">
				<div v-show="next && curInst.id!=''">
					<div>
						<component :is="curInst.id" ref="instComp" :from="monitor" :delCmd="delCmd"></component>
					</div>
				</div>
				<div v-show="!next || curInst.id == ''">
					<div>
						<p>您将要发送{{curInst.name}}指令到VE{{curInst.dId}} |  {{curInstVInfo.showFiled1}}车辆中，</p>
						<p>确定要继续吗？</p>
					</div>
					<div slot="footer" class="text-right">
						<button v-if="!next||curInst.id==''" class="btn btn-primary" @click="instWithdrawBtn">取消</button> 
						<button v-if="!next||curInst.id==''" class="btn btn-primary" @click="instConfirmBtn">确定</button>
					</div>	
				</div>
			</tab-modal>
			<!--tabModal3关注对话框->from VehicleList-->
			<tab-modal ref="modal3" size="small" title="关注车辆" v-on:cancel="closeModal3">
				<div>
					<div class="form-group">
						<input type="radio" name="r" value="0" v-model="picked"/>请选择车辆关注面板：
						<select class="form-control" v-model="oldPanel" :disabled="picked!=0">
						 	<option :value="tab.id" v-for="(tab,index) in tabName" >{{tab.tagpanelName}}</option>
						</select>
					</div>
					<div class="form-group" v-bind:class="{ 'form-group--error': $v.newPanel.$error }">
						<input type="radio" name="r" value="1" v-model="picked"/>新建车辆关注面板
					 	<input type="text" class="form-control" v-model.trim="newPanel" :disabled="picked!=1" @focus="$v.newPanel.$touch()"/>
						<span class="form-group__message cus_message" v-if="!$v.newPanel.maxLength">您的命名太长</span>
					</div>
				</div>
				<div slot="footer">			
					<button class="btn btn-primary" @click="saveBtn" :disabled="!disabled">保存</button>
				</div>
			</tab-modal>
			<!--tabModal弹框->消息弹框-->
			<tab-modal v-on:cancel="closeModal" ref="modal" size="small" title="温馨提示">	
				<div>
					<p v-html="tipContent"></p>
				</div>
				<div slot="footer">	
					<button class="btn btn-primary" @click="stopSaveStyle" v-if="saveLayout==0">取消</button>
					<button class="btn btn-primary" @click="tipConfirmBtn">确定</button>
				</div>	
			</tab-modal>
		</div>
	</template>
<script>
	import { required, maxLength } from 'vuelidate/lib/validators'
	import SubPage from 'components/common/SubPage'
	import PageAlarmHandleEdit from 'components/pages/alarmhandle/PageAlarmHandleEdit'
	import {OPERATE_EXCEPTION} from 'static/message'
	import TabModal from 'components/common/TabModal'
	import MonitorMap from 'components/common/Map/MonitorMap.vue'
	import {mapState} from 'vuex'
	import TabSearch from './TabSearch'
	import MenuStatus from './MenuStatus'
	import InsGoloxLoading from 'components/pages/vehiclemonitor/instructions/InsGoloxLoading'
	import InsGoloxObd from 'components/pages/vehiclemonitor/instructions/InsGoloxObd'
	import InsGoloxWifi from 'components/pages/vehiclemonitor/instructions/InsGoloxWifi'
	import InsGT02BLbsPosition from 'components/pages/vehiclemonitor/instructions/InsGT02BLbsPosition'
	import InsGT02LbsPosition from 'components/pages/vehiclemonitor/instructions/InsGT02LbsPosition'
	import InsGT520CaliMile from 'components/pages/vehiclemonitor/instructions/InsGT520CaliMile'
	import InsGT520CaliVehicles from 'components/pages/vehiclemonitor/instructions/InsGT520CaliVehicles'
	import InsGT520Port from 'components/pages/vehiclemonitor/instructions/InsGT520Port'
	import InsGT750Port from 'components/pages/vehiclemonitor/instructions/InsGT750Port'
	import InsMG50CaliMile from 'components/pages/vehiclemonitor/instructions/InsMG50CaliMile'
	import InsMG50CaliVehicles from 'components/pages/vehiclemonitor/instructions/InsMG50CaliVehicles'
	import InsMG50Port from 'components/pages/vehiclemonitor/instructions/InsMG50Port'
	import InsOCARCaliMile from 'components/pages/vehiclemonitor/instructions/InsOCARCaliMile'
	import InsOCARObd from 'components/pages/vehiclemonitor/instructions/InsOCARObd'
	import InsOCARPort from 'components/pages/vehiclemonitor/instructions/InsOCARPort'
	import InsBKAlarmClock from 'components/pages/vehiclemonitor/instructions/InsBKAlarmClock'
	import InsBKMonitor from 'components/pages/vehiclemonitor/instructions/InsBKMonitor'
	import InsBKAPN from 'components/pages/vehiclemonitor/instructions/InsBKAPN'
	import InsBKPort from 'components/pages/vehiclemonitor/instructions/InsBKPort'
	import InsBKTrack from 'components/pages/vehiclemonitor/instructions/InsBKTrack'
	
	import InsGT740AlarmClockModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740AlarmClockModeSet'
	import InsGT740DefaultedModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740DefaultedModeSet'
	import InsGT740GSMOpenSet from 'components/pages/vehiclemonitor/instructions/InsGT740GSMOpenSet'
	import InsGT740LowPowerAlarm from 'components/pages/vehiclemonitor/instructions/InsGT740LowPowerAlarm'
	import InsGT740VibrationAlarmSet from 'components/pages/vehiclemonitor/instructions/InsGT740VibrationAlarmSet'
	import InsGT740WeekModeSet from 'components/pages/vehiclemonitor/instructions/InsGT740WeekModeSet'
	import InsGT420setWorkMode from 'components/pages/vehiclemonitor/instructions/InsGT420setWorkMode'
	
	import classlist from 'util/classlist'
	export default{
		name:'PageVehicleMonitor',
		components: {
			MonitorMap,
			TabSearch,
			MenuStatus,
			TabModal,
			SubPage,
			PageAlarmHandleEdit,
			InsGoloxLoading,
			InsGoloxObd,
			InsGoloxWifi,
			InsGT02BLbsPosition,
			InsGT02LbsPosition,
			InsGT520CaliMile,
			InsGT520CaliVehicles,
			InsGT520Port,
			InsGT750Port,
			InsMG50CaliMile,
			InsMG50CaliVehicles,
			InsMG50Port,
			InsOCARCaliMile,
			InsOCARObd,
			InsOCARPort,
			InsBKAlarmClock,
			InsBKMonitor,
			InsBKTrack,
			InsBKPort,
			InsBKAPN,
			InsGT740AlarmClockModeSet,
			InsGT740DefaultedModeSet,
			InsGT740GSMOpenSet,
			InsGT740LowPowerAlarm,
			InsGT740VibrationAlarmSet,
			InsGT740WeekModeSet,
			InsGT420setWorkMode
		},
		data(){
			return { 
				picked:0,	    //选择将关注车辆添加到新面板还是旧面板
				oldPanel:'',	
				newPanel:'',
				modalTitle:'删除围栏',//删除围栏还是删除路线
				areaType:'围栏',	//是围栏还是路线区域
				vehicleAmount:0,  //路线或围栏内的车辆数量
				delMap:true,     //是否删除围栏、路线等还是删除关注面板
				//预警处理详情弹框-subpage
				subPageTitle:'预警处理',
				scrollTop:'',	//subpage滚动值
				monitor:'monitor',
				delCmd:false
			}
		},
		validations:{
			newPanel:{
				required,
				maxLength:maxLength(50)
			}
		},
		computed:{
			disabled(){
				return this.$v.newPanel.maxLength && this.$v.newPanel.required || this.oldPanel != ''
			},
			oldIndex:function(){
				const panelIndex = this.tabName.findIndex(n=>n.id == this.oldPanel)
				return panelIndex + 1
			},
			...mapState({
				showTabMap:state=>state.monitor.showTabMap,
				delInfo:state=>state.monitor.delInfo,
				showDelModal:state=>state.monitor.showDelModal,
				showInstModal:state=>state.monitor.showInstModal,
				showFollowModal:state=>state.monitor.showFollowModal,
				showTipModal:state=>state.monitor.showTipModal,
				tipContent:state=>state.monitor.tipContent,	//提示弹框信息
				tabName:state=>state.monitor.tabName,
				followVehicleId:state=>state.monitor.followVehicleId,
				followType:state=>state.monitor.followType,
				curInst:state=>state.monitor.curInst,		//派发指令信息
				showSubPage:state=>state.monitor.showSubPage, //是否显示subPage弹框
				alarmDetail:state=>state.monitor.alarmDetail, //预警详情信息
				curInstVInfo:state=>state.monitor.curInstVInfo, //派发指令的车辆信息
				cmdStr:state=>state.monitor.cmdStr,
				next:state=>state.monitor.next,
				groupId:state=>state.user.groupid,
				saveLayout:state=>state.monitor.saveLayout
			})
		},
		watch:{
			showDelModal:function(val){
				if(val){
					this.$refs.modalD.open()
				}else{
					this.$refs.modalD.close()
				}
			},
			delInfo:function(val){
				if(val){
					if(val.type=='panel'){
						this.delMap =false;
						this.modalTitle = "删除关注面板"
					}else{
						this.delMap =true;
						this.modalTitle = '删除' + val.type
					}
				}
			},
			showInstModal:function(val){
				if(val){
					this.delCmd = false
					this.$refs.modal1.open()
				}else{
					this.$refs.modal1.close()
				}
			},
			showFollowModal:function(val){
				if(val){
					this.$refs.modal3.open()
				}else{
					this.$refs.modal3.close()
					this.newPanel = ''
					this.$v.newPanel.$reset()
				}
			},
			showTipModal:function(val){
				if(val){
					this.$refs.modal.open()
				}else{
					this.$refs.modal.close()
				}
			},
			showConfirmModal:function(val){
				if(val){
					this.$refs.modalConfirm.open()
				}else{
					this.$refs.modalConfirm.close()
				}
			},
			picked:function(val){
				if(val==0){
					this.newPanel = '';
					this.$v.newPanel.$reset()
				}else{
					this.oldPanel = '';
				}
			},
			showSubPage(val){
				if(val) {
					classlist.toggleScroll('close','#monitor',this);
				}else{
					classlist.toggleScroll('open','#monitor',this);
				}
			}
		},
		beforeMount(){
			this.$store.dispatch('initMapTab')
		},
		
		methods: {
			/*删除弹框部分*/
			delWithdrawBtn(){//取消
				this.$refs.modalD.close()
				this.$store.dispatch('deleteModalHide')
			},
			delConfirmBtn(){//确定
				if(this.delInfo.type=='panel'){
					const id = this.delInfo.panelId	
					const param = {
						tagpanelId:id
					}
					this.$http.delete(process.env.API_ROOT + '/monitor/tagpanel/',{params:param})
					.then((res)=>{
						if(res.body.code=='200'){
					//		this.$store.dispatch('getFollowList')
							this.$store.dispatch('goVehicleList')
							this.$store.dispatch('getAllFollow')//初始化用户关注面板信息
							this.$store.dispatch('getFollowList')//获取用户原有关注面板信息（不含车辆）
							this.$store.dispatch('deleteModalHide')
						}else{
							this.$store.dispatch('tipModalShow',res.body.message)
						}
					},(res)=>{
						this.$store.dispatch('tipModalShow',res.body.message)
					})
					.catch((res)=>{
						this.$store.dispatch('tipModalShow',res.body.message)
					})
				}
				if(this.delInfo.type != 'panel'){
					const obj = {
						id:this.delInfo.id,
						type:this.delInfo.delType,
						groupId:this.groupId,
						uni:new Date().getTime()
					}
					this.$store.dispatch('deleteArea',obj)
					this.closeModalD()
				}
			},
			closeModalD(){
				this.$refs.modalD.close()
				this.$store.dispatch('deleteModalHide')
			},
			/*指令弹框部分*/
			instWithdrawBtn(){//取消按钮--返回上一步
				if(this.curInst.id===''){
					this.$refs.modal1.close()
					this.$store.dispatch('instModalHide')
				}else{
					this.$store.dispatch('nextClickable')
				}
			},
			instConfirmBtn(){//确认按钮
				this.$store.dispatch('nextClickable')
				this.$refs.modal1.close()
				this.$store.dispatch('instModalHide')
				const that = this
				let p = this.dispatchIns()
				p.then(function(){
					if(that.curInst.id == 'InsOCARCaliMile' && that.curInst.time==1){
						const obj = {
								name:that.curInst.name,		//指令名称
								id:that.curInst.id,        //指令对应组件名
								cmdType:that.curInst.cmdType,   //命令类型0:网路指令；1:短信指令
								dId:that.curInst.dId,
								cmd:that.curInst.cmd,
								time:2
						}
						that.$store.dispatch('instModalShow',obj)	
					}
				})
			},
			dispatchIns(){
				const obj =  {
						cmd:this.curInst.id=='' ? this.curInst.cmd : this.cmdStr.join(','),
						cmdName:this.curInst.name,
						cmdType:this.curInst.cmdType,
						deviceId:this.curInst.dId,
						source:'0',
						vehicleId:this.curInstVInfo.vehicleId
				}
				const that = this
				let p = new Promise(function(resolve,reject){
					//'/monitor/instruction/instus/',obj
					//'/monitor/instruction/instus/?cmd=' + obj.cmd + '&cmdName=' + obj.cmdName + '&cmdType=' + obj.cmdType + '&deviceId=' + obj.deviceId + '&source=0&vehicleId=' + obj.vehicleId
					that.$http.post(process.env.API_ROOT + '/monitor/instruction/instus/?cmd=' + obj.cmd + '&cmdName=' + obj.cmdName + '&cmdType=' + obj.cmdType + '&deviceId=' + obj.deviceId + '&source=0&vehicleId=' + obj.vehicleId)
					.then((response) => {
						if(that.curInst.id=='InsOCARCaliMile' && that.curInst.time == 1){
							resolve()
						}else{
							that.$store.dispatch('tipModalShow','指令发送成功')
							that.delCmd = true;
						}
					},(response)=>{
						if(that.curInst.id=='InsOCARCaliMile' && that.curInst.time == 1){
							resolve()
						}else{
							that.$store.dispatch('tipModalShow',response.body.message)
						}
					})
					.catch((response)=>{
						that.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
					})
				})
				return p
			},
			closeModal1(){//关闭按钮
				this.$refs.modal1.close()
				this.$store.dispatch('instModalHide')
				this.delCmd = true
			},
			/*添加车辆到关注面板弹框部分*/
			saveBtn(){//保存
				if(this.picked==0){//添加到已有关注面板this.oldPanel	
					const self = this;
					if(this.followType==0){//单个
						this.oneToFollow(self.oldPanel,self.followVehicleId,'oldP')//把车辆分支对应的车加到对应面板
					}else if(this.followType==1){//批量
						this.allToFollow(self.oldPanel,'oldP')//把底部车辆一览的多辆车加到对应面板（oldPanel是对应面板id）
					}
				}else{//添加到新建关注面板---先新增关注面板并返回新增面板ID
					const obj0 = this.tabName.find(n=>n.name === this.newPanel);
					if(obj0 === undefined){
						this.$http.post(process.env.API_ROOT + '/monitor/tagpanel/?tagpanelName=' + this.newPanel)
						.then((res)=>{
							if(res.body.success){
								const _self = this;
								if(this.followType==0){//单个
									this.oneToFollow(res.body.data,_self.followVehicleId,'newP')
								}else if(this.followType==1){//批量
									this.allToFollow(res.body.data,'newP')
								}
								
							}
						},(res)=>{
							this.$store.dispatch('tipModalShow',res.body.message)
						})
						.catch((res)=>{
							this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
						})
					}else{
						this.$store.dispatch('tipModalShow','您已有该名字的关注面板，直接在上面下拉框中选择该面板')
					}
				}
				this.$refs.modal3.close();
				this.$store.dispatch('followModalHide')
			},
			oneToFollow(panelId,vehicleId,addType){//往对应关注面板添加车辆
				const param = {
					tagpanelId:panelId,
					vehicleId:vehicleId
				}
				//'/monitor/tagplanel/vehicles',param
				//'/monitor/tagplanel/vehicles?tagpanelId=' + panelId + '&vehicleId=' + vehicleId
				this.$http.post(process.env.API_ROOT + '/monitor/tagpanel/vehicles?tagpanelId=' + panelId + '&vehicleId=' + vehicleId)
					.then((res)=>{
						if(res.body.success){
							let panelName = ''
							if(addType=='oldP'){
								const index = this.tabName.findIndex(n=>n.id==panelId);
								panelName = this.tabName[index].tagpanelName;
								this.$store.dispatch('getAllFollow',panelId)//初始化用户关注面板信息
								this.$store.dispatch('getFollowList')//获取用户原有关注面板信息（不含车辆）
							}
							if(addType=='newP'){
								panelName = this.newPanel
								this.$store.dispatch('getAllFollow',panelId)//初始化用户关注面板信息
								this.$store.dispatch('getFollowList')//获取用户原有关注面板信息（不含车辆）
							}
							
						}
					},(res)=>{
						this.$store.dispatch('tipModalShow',res.body.message)
					})
					.catch((res)=>{
						this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
					})
			},
			allToFollow(panelId,addType){//往对应关注面板添加车辆一览所有的车
				let obj = {tagpanelId:panelId}
				//'/monitor/tagplanel/batch/vehicles',obj
				//'/monitor/tagplanel/batch/vehicles?tagpanelId=' + panelId
				this.$http.post(process.env.API_ROOT + '/monitor/tagpanel/batch/vehicles?tagpanelId=' + panelId)
					.then((res)=>{
						if(res.body.success){
							this.$store.dispatch('getAllFollow',panelId)//初始化用户关注面板信息
							this.$store.dispatch('getFollowList')//获取用户原有关注面板信息（不含车辆）
						}
					},(res)=>{
						this.$store.dispatch('tipModalShow',res.body.message)
					})
					.catch((res)=>{
						this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
					})
			},
			closeModal3(){//关闭
				this.$refs.modal3.close()
				this.$store.dispatch('followModalHide')
			},
			/*消息弹框部分*/
			tipConfirmBtn(){//确认tip
				this.$refs.modal.close()
				this.$store.dispatch('tipModalHide')
				if(this.saveLayout == 0){
					this.$store.dispatch('savePageStyle',1)
				}
			},
			stopSaveStyle(){//取消保存界面布局
				this.$refs.modal.close()
				this.$store.dispatch('tipModalHide')
				this.$store.dispatch('savePageStyle',2)
			},
			closeModal(){//关闭tip
				this.$refs.modal.close()
				this.$store.dispatch('tipModalHide')
				this.$store.dispatch('savePageStyle',2)
			},
			/*预警处理弹框*/
			closeSubPage(){//关闭subpage
				this.$store.dispatch('closeAlarmDetail');
			},
			/*保存预警处理成功*/
			saveSubPage(almLevel){
				var parm = {
					almLevel:almLevel,
					planOwnerType:1,
					page_index:1
				};
				this.$store.dispatch('showAlarmInfo', parm);
				this.$store.dispatch('getAlarmNum');
				this.$store.dispatch('closeAlarmDetail');
			}
		}
		
	} 
</script>
 



// WEBPACK FOOTER //
// PageVehicleMonitor.vue?4a9fe6ce